<template lang="html">
  <v-container fluid class="px-sm-10">
    <v-row>
      <v-col>
        <base-items store-module="categories" @items="items = $event" @state="state = $event">
          <v-card :loading="state.loading" class="mb-8">
            <v-card-title>
              <v-row align="center">
                <v-col cols="auto" class="headline">
                  Categories
                </v-col>
                <v-col>
                  <v-btn color="primary" fab depressed small @click="openItemForm(createNewItem())" :disabled="state.working"><v-icon>mdi-plus</v-icon></v-btn>
                </v-col>
              </v-row>
            </v-card-title>

            <v-card-text>
              <v-list v-if="sortedItems.length > 0">
                <draggable v-model="sortedItems" ghost-class="category-ghost" handle=".handle">
                  <v-list-item
                    class="d-flex pa-1 align-center"
                    v-for="item in sortedItems"
                    :key="item.id"
                    @click="openItemForm(item)"
                  >
                    <v-list-item-content>
                      <v-list-item-title>
                        {{item.title}}
                      </v-list-item-title>
                    </v-list-item-content>

                    <v-list-item-action class="d-flex flex-row align-center">
                      <div class="">
                        <v-btn text icon class="mx-5" @click.stop="deleteItem(item)" @mousedown.stop=""><v-icon>mdi-delete</v-icon></v-btn>
                      </div>

                      <div class="handle" @click.stop="" @mousedown.stop="">
                        <v-icon>mdi-drag-horizontal-variant</v-icon>
                      </div>
                    </v-list-item-action>
                  </v-list-item>
                </draggable>
              </v-list>
              <div v-else class="">
                No categories
              </div>
            </v-card-text>
          </v-card>
        </base-items>
      </v-col>
    </v-row>

    <item-view-dialog
      :value="!!editItem"
      @input="editItem = null"
      store-module="categories"
      max-width="600px"
      title="Category"
      :item="editItem"
    >
      <!-- Empty div as activator to hide default button -->
      <div></div>
      <template v-slot:itemForm="slotProps">
        <category-form v-bind="slotProps"></category-form>
      </template>
    </item-view-dialog>
  </v-container>
</template>

<script>
import draggable from 'vuedraggable';
import {BaseItems, ItemViewDialog} from 'dync-baseitem';
import CategoryForm from '../components/CategoryForm.vue';

export default {
  data () {
    return {
      editItem: null,
      items: [],
      state: {}
    };
  },
  computed: {
    sortedItems: {
      get () {
        var items = this.items.slice(0);
        items.sort((a, b) => (a.order || 0) - (b.order || 0));
        return items;
      },
      set (items) {
        const reorderedItems = items.map((item, i) => Object.assign({}, item, {order: i}));
        const reorderedItemsPayload = reorderedItems.map(item => ({id: item.id, order: item.order}));

        this.$store.commit('categories/replaceItems', reorderedItems);
        this.$store.dispatch('categories/updateItems', reorderedItemsPayload).then(() => {
        }).catch(() => {
          this.$store.commit('categories/replaceItems', items);
          this.$snackbar({message: 'Could not save order of categories', theme: 'error'});
        });
      }
    }
  },
  methods: {
    getNextOrderNumber(items) {
      var lastItem = items[items.length-1];
      if (lastItem && lastItem.order != undefined) {
        return lastItem.order + 1;
      } else {
        return 1;
      }
    },
    deleteItem (item) {
      this.$confirm({
        title: `Are you sure you want to delete category "${item.title}"?`,
        message: 'You cannot undo this action'
      }).then(() => {
        this.$store.dispatch('categories/deleteItem', item.id).then(() => {
          this.$snackbar({message: 'Category deleted', theme: 'success'})
        }).catch((error) => {
          console.error(error);
          this.$snackbar({message: 'Could not delete category', theme: 'error'})
        });
      });
    },
    openItemForm(item) {
      this.editItem = Object.assign({}, item);
    },
    closeItemForm() {
      this.editItem = null;
    },
    createNewItem() {
      return {
        title: '',
        category_type: 'product',
        order: this.getNextOrderNumber(this.sortedItems)
      };
    }
  },
  components: {
    BaseItems,
    draggable,
    CategoryForm,
    ItemViewDialog
  }
}
</script>

<style>
.category-ghost {
  background: var(--v-secondary-base);
}
</style>

<style lang="css" scoped>
.handle {
  cursor: grab;
}
</style>
